import { bbVars, assignConfig, initConnection } from './configuration';
import { bbCloseModal, bbGetUrlBase, showCheckout } from './interface';
import { bBPOST } from './http';
import { iniyPayMessage, initPayment, onFirstMessageRecived } from './pay';



let checkout = (config = {}, OrderId = 0) => {
    bbVars.bbfConfig = config;
    bbVars.bbToken = config.jwt;
    bbVars.bbOrderId = OrderId;
    bbVars.isFinalized = false;
    bbGetUrlBase();
    //initConnection();
    showCheckout();
    window.addEventListener('message', onFirstMessageRecived);
}

let initPay = (serverConfig = {}, localConfig = {}) => {
    bbGetUrlBase();
    assignConfig(serverConfig, localConfig);
    bbVars.bbMpagoLibLoaded = true;
    //setTimeout(() => initPayment(), 1000);
    initPayment();
    window.addEventListener('message', iniyPayMessage);

}

let closePay = () => {
    window.removeEventListener('message', iniyPayMessage);
}

var RequestNew = (data) => {
    bbGetUrlBase();
    if (!data) {
        data = {
            campusId: "340",
            reference: "REF0000123TEST",
            amount: 2000,
            urlNotifications: bbVars.bbfUrlBase + '',
            toCurrency: 'US',
            application: 'VIRTUAL-TELLER',
            onlySinchronous: true
        }
    }

    return bBPOST('test/request/mercadopago', data);
}

let onEventComplete = (func = () => {}) => {
    if (!!func) {
        bbVars.bbFunctionReturn = func;
    }
}

const closeWindow = bbCloseModal;

export { RequestNew, initPay, checkout, onEventComplete, closeWindow, closePay }